import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n      height: 30px;\n      margin: 5px;\n      position: relative;\n      width: 30px;\n      @media (max-width: ', ') {\n        height: 30px;\n        width: 30px;\n      }\n    '], ['\n      height: 30px;\n      margin: 5px;\n      position: relative;\n      width: 30px;\n      @media (max-width: ', ') {\n        height: 30px;\n        width: 30px;\n      }\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      background-color: ', ';\n      border: 1px solid ', ';\n      font-size: 14px;\n      margin: 5px;\n      padding: 5px;\n      text-align: center;\n    '], ['\n      background-color: ', ';\n      border: 1px solid ', ';\n      font-size: 14px;\n      margin: 5px;\n      padding: 5px;\n      text-align: center;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      display: block;\n      margin: 10px 0;\n      a {\n        color: ', ';\n      }\n      :hover,\n      :hover a {\n        color: ', ';\n      }\n    '], ['\n      display: block;\n      margin: 10px 0;\n      a {\n        color: ', ';\n      }\n      :hover,\n      :hover a {\n        color: ', ';\n      }\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n        background-color: ', ';\n        border-color: ', ';\n        color: ', ' !important;\n      '], ['\n        background-color: ', ';\n        border-color: ', ';\n        color: ', ' !important;\n      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n        &,\n        a {\n          color: ', ' !important;\n        }\n        font-weight: 700;\n      '], ['\n        &,\n        a {\n          color: ', ' !important;\n        }\n        font-weight: 700;\n      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  color: ', ';\n  cursor: pointer;\n  display: inline-block;\n  font-size: 15px;\n  white-space: nowrap;\n  ', '\n  ', '\n'], ['\n  color: ', ';\n  cursor: pointer;\n  display: inline-block;\n  font-size: 15px;\n  white-space: nowrap;\n  ', '\n  ', '\n']);

import styled, { css } from 'styled-components';

var ButtonStyleTypes = function ButtonStyleTypes(_ref) {
  var type = _ref.type,
      theme = _ref.theme;

  if (type === 'swatch') {
    return css(_templateObject, theme.tabletWidth);
  } else if (type == 'btn') {
    return css(_templateObject2, theme.dormifyWhite, theme.dormifyBlack);
  } else {
    /* type == listitem */
    return css(_templateObject3, theme.dormifyBlack, theme.dormifyPink);
  }
};

var ActiveButtonStyleTypes = function ActiveButtonStyleTypes(_ref2) {
  var active = _ref2.active,
      type = _ref2.type,
      theme = _ref2.theme;

  if (active) {
    if (type == 'btn') {
      return css(_templateObject4, theme.dormifyBlack, theme.dormifyBlack, theme.dormifyWhite);
    } else {
      return css(_templateObject5, theme.dormifyBlack);
    }
  }
};

export var StyledLi = styled.li(_templateObject6, function (props) {
  return props.theme.dormifyBlack;
}, ButtonStyleTypes, ActiveButtonStyleTypes);